import React from 'react';
import PropTypes from 'prop-types';

import { DODGER_BLUE } from '@constant/colors';

const Circle = ({ width, color }) => (
  <svg width={width} height={width} viewBox="0 0 18 18">
    <rect
      fill={color}
      fillRule="evenodd"
      x="1"
      y="1"
      width="16"
      height="16"
      rx="8"
    />
  </svg>
);

Circle.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Circle.defaultProps = {
  color: DODGER_BLUE,
  width: 18,
};

export default Circle;
